import React from 'react';

const AuditLogsTable = ({ heading, auditLogs }) => {
	const styles = {
		tableDiv: 'bg-white rounded-lg overflow-auto mb-14',
		select:
			'block appearance-none w-full bg-white border-1p border-[#F0F0F0] text-dark-blue py-2 px-4 pr-8 rounded-lg cursor-pointer',
		selectSVG:
			'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-dark-blue',
		bottomTableHead: 'px-5 py-4 text-left text-lg leading-100 font-medium text-gray',
		tableData: 'px-5 py-4 text-lg font-medium text-dark-blue leading-100 text-left'
	};

	return (
		<div>
			<div>
				<div className="flex justify-between mb-10">
					<div>
						<h2 className="text-[22px] font-medium text-dark-blue">{heading}</h2>
					</div>

					<div className="flex">
						<div className="relative">
							<select className={styles.select}>
								<option>This month</option>
								<option>Last month</option>
								<option>Last 3 months</option>
							</select>
							<div className={styles.selectSVG}>
								<svg
									className="fill-current h-4 w-4"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
								>
									<path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div className={styles.tableDiv}>
					<div className="w-full">
						<table className="min-w-[700px] xl:min-w-full">
							<thead className="bg-[#F2F3F7]">
								<tr>
									<th scope="col" className={styles.bottomTableHead}>
										ACTIVITY
									</th>
									<th scope="col" className={styles.bottomTableHead}>
										COMMENT
									</th>
									<th scope="col" className={styles.bottomTableHead}>
										EMAIL
									</th>
									<th scope="col" className={styles.bottomTableHead}>
										DATE/TIME
									</th>
								</tr>
							</thead>
							<tbody className="bg-white">
								{auditLogs.map((log, idx) => (
									<tr key={idx}>
										<td className={styles.tableData}>{log.activity}</td>
										<td className={styles.tableData}>{log.comment}</td>
										<td className={styles.tableData}>{log.email}</td>
										<td className={styles.tableData}>{log.datetime}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AuditLogsTable;
